import React from "react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";

import parlorSocialClub from "assets/graphics/icons/parlor-social-club.svg";

import "features/new/footer/component/view.scss";

const FooterView = ({ contactEmail }) => (
  <footer className="footer">
    <div className="footer__container">
      <a href="#">
        <img
          className="footer__logo"
          src={parlorSocialClub}
          alt="parlor social club"
        />
      </a>
      <ul className="footer__list">
        <li className="footer__item">
          <Link
            to="/terms-and-conditions"
            className="footer__link"
            target="blank"
            onClick={() => window.dataLayer.push({ event: "termsVisited" })}
          >
            Terms
          </Link>
        </li>
        <li className="footer__item">
          <Link
            to="/privacy-policy"
            className="footer__link"
            target="blank"
            onClick={() => window.dataLayer.push({ event: "privacyVisited" })}
          >
            Privacy
          </Link>
        </li>
        <li className="footer__item">
          <a
            className="footer__link"
            href={`mailto:${contactEmail}`}
            target="blank"
            onClick={() => {
              window.dataLayer.push({ event: "contactClicked" });
            }}
          >
            Contact
          </a>
        </li>
        <li className="footer__item">
          <a
            className="footer__link"
            href="https://www.instagram.com/parlor.social.club/"
            target="blank"
            onClick={() => window.dataLayer.push({ event: "instagramVisited" })}
          >
            Instagram
          </a>
        </li>
      </ul>
      <p className="footer__copyright">
        &copy; {new Date().getFullYear()} Parlor Social Club - All rights
        reserved.
      </p>
    </div>
  </footer>
);

FooterView.propTypes = { contactEmail: PropTypes.string };

export default FooterView;
